<template>
  <v-layout shrink align-baseline class="status-counters" px-1>
    <v-tooltip top v-for="(status, i) in getStatuses" :key='i' color="transparent">
        <v-layout column shrink class="status-counter" @click="() => clickHandler(status)" :class="status.back_color" :style="`background-color: ${status.back_color}; margin-left: ${i ? '3px' : '0px'};`" align-center justify-center slot="activator">
          <span class="caption white--text">{{ $store.getters.getCounters[status.name] }}</span>
        </v-layout>
      <span class="uppercase blacktext--text">{{$t(status.name)}}</span>
      <span class="uppercase blacktext--text">{{$store.getters.getCounters[status.name]}}</span>
    </v-tooltip>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'

// Типы для статусов
interface StatusItem {
  name: string
  [key: string]: any
}

interface MeasureDescriptor {
  $id: string
  name: string
  measure_id?: string
  [key: string]: any
}

interface CounterData {
  id: string
  value: any
}

export default Vue.extend({

  name: 'STATUSES',

  props: {},

  components: {},

  data(): {
    icons: Record<string, string>
  } {
    return {
      icons: {
        unknown: 'help_outline',
        notification: 'info',
        damage: 'bolt',
        alarm: 'whatshot',
        warning: 'priority_high',
        maintenance: 'build'
      }
    }
  },

  computed: {
    getStatuses(): StatusItem[] | undefined {
      const list$ = this.$store.state.books.books.filter((book: StatusItem) => {
        return book.name === 'state'
      })
      
      if (list$.length) {
        const res = list$[0].children.filter((child: StatusItem) => {
          return this.$store.getters.getDefaultStatuses.includes(child.name)
        })
        return res
      }
      return undefined
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.countersSubscribe()
    },

    async countersSubscribe(): Promise<void> {
      const counters$ = await this.$bridge.getByPath('/config/server')
      // console.log(this.$options.name, 'countersSubscribe', 'counters$', counters$)
      const measuresDescriptor: MeasureDescriptor[] = await counters$.getMeasures()
      // console.log(this.$options.name, 'countersSubscribe', 'measuresDescriptor', measuresDescriptor)
      const counterMeasuresDescr = measuresDescriptor
        .filter((el: MeasureDescriptor) => el.name.indexOf('measure') >= 0)
        .reduce((acc: Record<string, MeasureDescriptor>, el: MeasureDescriptor) => {
          acc[el.$id] = el
          return acc
        }, {})
      // console.log(this.$options.name, 'countersSubscribe', 'counterMeasuresDescr', counterMeasuresDescr)
      const handler$ = (e: { $id: string; value: any }) => {
        // console.log(this.$options.name, 'countersSubscribe', 'handler e', e)
        const measureId = counterMeasuresDescr[e.$id]?.measure_id
        if (measureId) {
          const counter: CounterData = {
            id: measureId.replace('measure_', ''),
            value: e.value
          }
          this.$store.commit('LOAD_COUNTERS', counter)
        }
      }
      
      this.$store.dispatch('measuresSubscribeInit', {
        handler: handler$,
        group: 'counters',
        listener: 'data'
      })
      counters$.subscribeMeasures('counters')

      // console.log(this.$options.name, 'countersSubscribe', 'getStatuses', this.getStatuses)
      // console.log(this.$options.name, 'countersSubscribe', 'this.$store.getters.getCounters', this.$store.getters.getCounters)

    },

    clickHandler(status: StatusItem): void {
      console.log(this.$options.name, 'clickHandler', 'status', status)
      this.$emit('status', status)
    },

    getIcon(status: string): string {
      return this.icons[status] || 'help_outline'
    },
  },
})
</script>

<style lang="css" scoped>

.status-counters {
  background-color: #EBEBEB;
  border: solid #E1E1E1 1px;
  border-radius: 14px;
  height: 28px!important;
}
.status-counter {
  width: 24px!important;
  height: 24px!important;
  border-radius: 12px;
}
</style>
